import { Box } from "@mui/material"
import type { ColumnDef, ColumnSort, OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Role } from "@/graphql/codegen/graphql"

interface RolesTableProps {
  data: Role[]
  fetching: boolean
  scrollHandler: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  columns: ColumnDef<Role>[]
  handleSortingChange: (updaterFn: (state: SortingState) => SortingState) => void
  sorting: ColumnSort[]
  error?: Error
}

const RolesTable: FC<RolesTableProps> = ({
  data,
  error,
  scrollHandler,
  handleSortingChange,
  columns,
  sorting,
  tableContainerRef,
  fetching,
}) => {
  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable<Role>
        error={error}
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data,
            columns,
            state: {
              sorting,
              isLoading: fetching,
            },
            manualSorting: true,
            enableSorting: true,
            enableMultiSort: false,
            enableSortingRemoval: false,
            getCoreRowModel: getCoreRowModel(),
            onSortingChange: handleSortingChange as OnChangeFn<SortingState>,
          },
        }}
        slotProps={{
          container: {
            ref: tableContainerRef,
            onScroll: scrollHandler,
          },
          bodyRow: {
            className: "hover:bg-primary-100 cursor-pointer",
          },
        }}
        noDataMessage='No roles found'
      />
    </Box>
  )
}

export default RolesTable
